module.exports = __webpack_public_path__ + "media/44s.ff700725.mp3";